import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core'
import { GiftSportItem, sortedVerticalGifts, GIFT_SUB_VERTICALS } from './choose-sport.data'
import { Router } from '@angular/router'
import {
  GIFT_SUBSCRIPTION_CHOOSE_SPORT_ANALYTICS_TAG,
  GiftSubscriptionAnalyticsService
} from '../gift-subscription-analytics.service'
import { PlatformService } from '../../singleton-services/platform.service'
import { WINDOW } from '../../app.injections'

@Component({
  selector: 'flo-choose-sport',
  templateUrl: './choose-sport.component.html',
  styleUrls: ['./choose-sport.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChooseSportComponent implements OnInit {
  sportsGiftList = sortedVerticalGifts(GIFT_SUB_VERTICALS)
  selectedVertical: GiftSportItem

  constructor(
    private readonly analytics: GiftSubscriptionAnalyticsService,
    private readonly router: Router,
    private readonly platformService: PlatformService,
    @Inject(WINDOW) private readonly window: Window
  ) {}

  @Input()
  public directNavigation = false
  ngOnInit() {
    this.analytics.sendGiftPageCall(GIFT_SUBSCRIPTION_CHOOSE_SPORT_ANALYTICS_TAG, 'Giftee')
  }
  public get canSubmit() {
    return !!this.selectedVertical
  }

  selectVertical(giftSportItem: GiftSportItem): void {
    if (this.directNavigation && this.platformService.isBrowser) {
      this.window.location.href = giftSportItem.url
    }
    // must select a vertical that is on the new pricing architecture
    if (!giftSportItem.comingSoon) {
      this.selectedVertical = giftSportItem
    }
  }

  public onSubmit() {
    this.router.navigate(['/gift/overview'], {
      queryParams: {
        siteId: this.selectedVertical.siteId,
        redirect: this.selectedVertical.url
      }
    })
  }
}
